export enum FieldType {
	NoData = "0. NO_DATA",            // No data rows to analyze
	OneValue = "1. ONE_VALUE",        // Cardinality is 1
	SelectValues = "2. SELECT_VALUES",// Suitable for pivoting
	ManyValues = "3. MANY_VALUES",    // Cardinality is high (e.g., > 20% of NumRows)
	AllUnique = "4. ALL_UNIQUE",      // Cardinality is very high (e.g., equal to NumRows)
	TimeStamp = "5. TIMESTAMP"        // possibly a timestamp field (ex: name has "time" in it and field is MANY or ALL UNIQUE type)
}

export interface ValueCount {
  value: string;
  count: number;
}

export interface DataDictionaryEntry {
  fieldName: string;
  fieldType: FieldType;
  cardinality: number;
  pivots?: ValueCount[];  // Pivots are included based on FieldType
	minTimestamp?: string;  // Min timestamp if FieldType is TIMESTAMP
  maxTimestamp?: string;  // Max timestamp if FieldType is TIMESTAMP

}

export interface SummaryStats {
  dataTitle: string; // friendly name to identify this dataset
  numFields: number;
  numRows: number; // Number of data rows (excluding header)
  fieldTypeDistribution?: { [key: string]: number };
}

export interface LogAnalysisResult {
  summary: SummaryStats;
  dataDictionary: DataDictionaryEntry[];
  error?: string;
}

// Helper type for the state
export interface CsvAnalysisData {
  result: LogAnalysisResult | null;
  error: string | null;
  isLoading: boolean;
}